import { render, staticRenderFns } from "./SalesOrderDetail.vue?vue&type=template&id=3d5857e5&scoped=true&"
import script from "./SalesOrderDetail.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SalesOrderDetail.vue?vue&type=style&index=0&id=3d5857e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5857e5",
  null
  
)

export default component.exports